import { ApplicationConfig, inject, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { RouteReuseStrategy, provideRouter, withRouterConfig } from '@angular/router';
import { provideNgIconsConfig } from '@ng-icons/core';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';

import { routes } from './app.routes';
import { createMarkdownRenderer } from './core/markdown/markdown-renderer';
import { RemountOnParamChange } from './core/routing/remount-on-param-change/remount-on-param-change';
import { httpInterceptors } from './core/http/interceptors/http-interceptors';
import { translocoProviders } from './core/i18n/transloco.providers';
import { AUTH_REFRESH } from './core/auth/tokens/auth-session.token';
import { AuthFeatureService } from './core/auth/services/auth.service';
import { TEACHER_CONTENT } from './shared/content/teacher-content.contract';
import { StrapiTeacherContent } from './shared/content/strapi-teacher-content/strapi-teacher-content.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    { provide: RouteReuseStrategy, useClass: RemountOnParamChange },
    provideHttpClient(withInterceptors(httpInterceptors)),
    ...translocoProviders,
    provideNgIconsConfig({ size: '1.5rem' }),

    { provide: TEACHER_CONTENT, useClass: StrapiTeacherContent },
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: { renderer: createMarkdownRenderer() },
      },
    }),
    {
      provide: AUTH_REFRESH,
      useFactory: () => {
        const auth = inject(AuthFeatureService);
        return () => auth.refreshSession();
      },
    },
  ],
};
